<template>
  <div>
    <vs-button type="border" color="success" size="small" @click="$router.push('/payments')">£ {{ getCurrentCompanyWallet }}</vs-button>
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <span class="cursor-pointer flex items-center i18n-locale">
        <span class="h-4 w-7 sm:block ml-2 text-success">{{ getCurrentCompanyData }}</span>
        <!-- <span class="hidden sm:block ml-2"> {{ getCurrentCompanyData }}</span> -->
      </span>
      <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
        <vs-dropdown-item
          v-for="company in companies"
          v-bind:key="company.id"
          @click="updateCompany(company)"
        >&nbsp;{{company.name}}</vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import { _list } from "@/services/Company";
export default {
  beforeMount() {
    _list()
      .then(
        (res) => {
          this.companies = res.data.obj.list;
          this.mounted = true;
        },
        (err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("auth/doLogout").then(() => {
              this.$acl.change("admin");
              localStorage.removeItem("userInfo");
              this.$router.push("/login").catch(() => {});
            });
          }
        }
      )
      .catch((err) => {
        console.log("catch");
        console.log(err.message);
      });
  },
  data() {
    return {
      companies: [],
      mounted: false,
    };
  },
  computed: {
    // i18n_locale_img() {
    //   return require(`@/assets/images/flags/${this.$i18n.locale}.png`)
    // },
    getCurrentCompanyData() {
      if (this.mounted) {
        this.updateCompany(this.companies[0]);
        this.mounted = false;
        return this.$store.getters["company/getCompanyName"];
      }
      if (this.companies.length > 0) {
        if (
          this.companies.some(
            (c) => c.name == this.$store.getters["company/getCompanyName"]
          )
        )
          return this.$store.getters["company/getCompanyName"];
        else {
          this.updateCompany(this.companies[0]);
          return this.$store.getters["company/getCompanyName"];
        }
      }
    },
    getCurrentCompanyWallet() {
      if (this.mounted) {
        this.updateCompany(this.companies[0]);
        this.mounted = false;
        return this.$store.getters["company/getCompanyWallet"];
      }
      if (this.companies.length > 0) {
        if (
          this.companies.some(
            (c) => c.name == this.$store.getters["company/getCompanyName"]
          )
        )
          return this.$store.getters["company/getCompanyWallet"];
        else {
          this.updateCompany(this.companies[0]);
          return this.$store.getters["company/getCompanyWallet"];
        }
      }
    },
  },
  methods: {
    updateCompany(company) {
      this.$store.commit("company/UPDATE_DASHBOARD_COMPANY", company, {
        root: true,
      });
    },
    updateLocale(locale) {
      this.$i18n.locale = locale;
    },
  },
};
</script>
